import React from 'react';

export class ToolbarButton extends React.PureComponent {
  render() {
    return (
      <div className="toolbar-item">
        <button {...this.props} />
      </div>
    );
  }
}
